import { render, staticRenderFns } from "./FileNotFoundRoute.vue?vue&type=template&id=39bca082&"
import script from "./FileNotFoundRoute.vue?vue&type=script&lang=js&"
export * from "./FileNotFoundRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports